module.exports = __webpack_public_path__ + "img/slider (2).a09b05b4.png";